<template>
    <div class="card shadowed">
        <div class="card-body">
            <div class="card-body-icon" data-animation="true">
                <span class="icon">
                    <i class="fa fa-fw fa-lg fa-2x" :class="icon"></i>
                </span>
            </div>
            <p class="card-body-label">{{ label }}</p>
            <h3 v-if="!loading" class="card-body-value"><span class="value-prefix">{{ prefix }}</span> {{ value }} <span class="value-suffix">{{ suffix }}</span></h3>
            <h3 v-else class="card-body-value"><i class="fa fa-fw fa-circle-notch fa-spin"></i></h3>
        </div>
    </div>
</template>

<script>
export default {
	name: "DashboardCard2",
    
    props: [ "icon", "label", "prefix", "value", "suffix", "loading" ],
}
</script>

<style scoped>
.card {
	position: relative;
	display: block;
	height: auto;
	width: 100%;
	background-color: #fff;
	border-bottom: 1px solid #f0f0f0;
	/*border-radius: 4px;*/
	margin-bottom: 15px;
}

.card-header,
.card-body,
.card-footer {
	padding: 15px;
}

.card-header {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
    background-color: #f0f0f0;
	text-align: center;
	font-size: 12px;
}

.card-body {
    position: relative;
    display: grid;
    vertical-align: center;
	border-radius: 4px;
}

.card-body-icon {
    position: absolute;
    width: 100%;
	color: #ddd;
	font-size: 20px;
    margin: 15px 0px 0px 5px;
    text-align: left;
    z-index: 0;
}

.card-body-icon[data-animation="true"] {
	-webkit-transform: translateZ(0);
	transform: translateZ(0);
	-webkit-transition: all .3s cubic-bezier(.34,1.61,.7,1);
	transition: all .3s cubic-bezier(.34,1.61,.7,1);
}

.card:hover > .card-body > .card-body-icon[data-animation="true"] {
	-webkit-transform: translate3d(0,-5px,0);
	transform: translate3d(0,-5px,0);
}

.card-body-icon > span.icon {
	color: #eee;
	font-size: 25px;
}

.card-body-icon > span.icon > i {
	-ms-transform: rotate(-15deg);
    transform: rotate(-15deg);
}

p.card-body-label {
    position: relative;
	margin-block-start: 0px;
	margin-block-end: 5px;
	font-size: 12px;
	text-align: right;
	color: #a6a6a6;
    z-index: 2;
}

h3.card-body-value {
    position: relative;
	margin-block-start: 0px;
	margin-block-end: 0px;
	text-align: right;
    z-index: 2;
}

h3.card-body-value > span.value-prefix,
h3.card-body-value > span.value-suffix {
    position: relative;
    color: #4c6e8d;
	font-size: 16px;
    z-index: 2;
}

.card-footer {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
	background-color: #f0f0f0;
	text-align: center;
	font-size: 12px;
}

.card-footer a {
	text-decoration: none;
	color: #2c3e50;
}
</style>